export default {
  namespaced: true,

  state: {
    current: null,
  },

  getters: {
    current: (state) => state.current,
  },

  actions: {
    open({state, dispatch}, url) {
      if(typeof url !== 'string') console.warn("linkFrame url must be a string");
      else {
        dispatch('sidebar/close', null, {root:true});
        state.current = url;
      }
    },
    close({ state, dispatch, rootGetters }) {
      state.current = null;
      if(!rootGetters['sidebar/isOpen']) dispatch('sidebar/open', 'links', {root:true})
    }
  }
};